import { CircleLoader } from "react-spinners"

export function Loader({ size }: { size?: number }) {
	return (
		<div className="flex h-full w-full justify-center opacity-100 transition-opacity duration-1000 ease-out">
			<CircleLoader loading={true} color="#fff" size={size ?? 400} />
		</div>
	)
}
